import { api } from './api';

/**
 * Loyalty Devices
 * --------------
 */
export function getLoyaltyDevices(params) {
  return api.get(`/loyalty/devices`, {
    params
  });
}
export function getLoyaltyDevice(id) {
  return api.get(`/loyalty/devices/${id}`);
}
export function createLoyaltyDevice(data) {
  return api.post(`/loyalty/devices`, data);
}
export function updateLoyaltyDevice(id, data) {
  return api.patch(`/loyalty/devices/${id}`, data);
}
export function deleteLoyaltyDevice(id) {
  return api.delete(`/loyalty/devices/${id}`);
}
export function getDeviceActivationCode(id) {
  return api.get(`/loyalty/devices/${id}/activation-code`);
}
export function deactivateLoyaltyDevice(id) {
  return api.post(`/loyalty/devices/${id}/deactivate`);
}

/**
 * Loyalty Programs
 * --------------
 */
export function getLoyaltyPrograms(params) {
  return api.get(`/loyalty/programs`, {
    params
  });
}
export function getLoyaltyProgram(id) {
  return api.get(`/loyalty/programs/${id}`);
}
export function createLoyaltyProgram(data) {
  return api.post(`/loyalty/programs`, data);
}
export function updateLoyaltyProgram(id, data) {
  return api.patch(`/loyalty/programs/${id}`, data);
}
export function deleteLoyaltyProgram(id) {
  return api.delete(`/loyalty/programs/${id}`);
}

/**
 * Loyalty Members
 * --------------
 */
export function getLoyaltyMembers(params) {
  return api.get(`/loyalty/members`, {
    params
  });
}
export function getLoyaltyMember(id) {
  return api.get(`/loyalty/members/${id}`);
}

/**
 * Loyalty Groups
 * --------------
 */
export function getLoyaltyGroups(params) {
  return api.get(`/loyalty/groups`, {
    params
  });
}
export function getLoyaltyGroup(id) {
  return api.get(`/loyalty/groups/${id}`);
}
export function createLoyaltyGroup(data) {
  return api.post(`/loyalty/groups`, data);
}
export function updateLoyaltyGroup(id, data) {
  return api.patch(`/loyalty/groups/${id}`, data);
}
export function deleteLoyaltyGroup(id) {
  return api.delete(`/loyalty/groups/${id}`);
}
export function getLoyaltyGroupLocations(groupId, params) {
  return api.get(`/loyalty/groups/${groupId}/locations`, {
    params
  });
}

/**
 * Loyalty Points History
 */
export function getLoyaltyPointsHistory(id) {
  return api.get(`/loyalty/points-history/${id}`);
}
export function listLoyaltyPointsHistory(params) {
  return api.get(`/loyalty/points-history`, {
    params
  });
}